import React from 'react';
import type { UAPPlacementComponentProps } from '../../@types';

import { getAppAdsMobileStyles } from '../../styles/ad-placement-components/app-ads-ad-placement-styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { ResponsiveSearchAdPlacementBase } from '../responsive-search-ad-placements/responsive-search-ad-placement-base';


export const AppAdsBingSearchPlacementBase = (props: UAPPlacementComponentProps) => {
  const {
    shortHeadline,
    description,
    displayUrl,
    url,
    placementData,
    classes,
    showImageExtension,
    ...rest
  } = props;

  const {
    placementMeta,
    placementCropping,
    imageMeta,
    effectiveImageUrl,
    effectiveImageWidth,
    effectiveImageHeight,
    expandedPlacementCropping,
    imageCropping,
  } = placementData || {};

  const cropping = expandedPlacementCropping || placementCropping;
  const { previewHeight, aspectRatio } = placementMeta || {};

  const decoratorsData = showImageExtension && imageMeta && {
    imageExtension: {
      image: {
        src: effectiveImageUrl || imageMeta.url,
        width: effectiveImageWidth || imageMeta.width,
        height: effectiveImageHeight || imageMeta.height,
        cropSettings: {
          SourceWidth: cropping && cropping.SourceWidth,
          SourceX: cropping && cropping.SourceX,
          SourceY: cropping && cropping.SourceY,
        },
      },
      enableCrop: true,
    },
    enableCrop: imageCropping,
  };

  return (
    <ResponsiveSearchAdPlacementBase
      previewImageAspectRatio={aspectRatio}
      previewImageHeight={previewHeight}
      previewTexts={{
          longHeadline: shortHeadline,
          description,
          displayUrl,
          url,
        }}
      showImageExtension
      decoratorsData={decoratorsData}
      classes={classes}
      {...rest}
    />
  );
};

export const AppAdsBingSearchPlacement = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => <AppAdsBingSearchPlacementBase {...props} showImageExtension />,
  getAppAdsMobileStyles,
  { componentName: 'AppAdsBingSearchPlacement' }
);

export const AppAdsBingSearchPlacementText = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => <AppAdsBingSearchPlacementBase {...props} showImageExtension={false} />,
  getAppAdsMobileStyles,
  { componentName: 'AppAdsBingSearchPlacementText' }
);
